import { WidgetModel } from '@jupyter-widgets/base';
import { uuid4 } from './crypto';

export interface ResponseEvent<T = any> {
  id: string;
  method: string;
  error?: string;
  response: T;
}

export namespace WidgetApi {
  const events: Map<string, { resolve: any; reject: any }> = new Map();

  export function init(modelContext: WidgetModel) {
    return {
      callMethod: async function callApiMethod<T, R = any>(
        method: string,
        params: T
      ): Promise<R> {
        const id = uuid4();
        const promise = new Promise<R>((resolve, reject) => {
          events.set(id, { resolve, reject });
        });

        modelContext.send({ id, method, params }, {});
        return promise;
      },
    };
  }

  export function handleEvent(event: ResponseEvent) {
    const handler = events.get(event.id);
    if (!handler) {
      return;
    }
    if ('error' in event) {
      handler.reject(event.error);
    } else {
      handler.resolve(event.response);
    }
    events.delete(event.id);
  }
}
